/**
 * Renders stored markdown — notes in full, quotes inline.
 *
 * See `@/lib/markdown` for why there are two levels and what each allows.
 */

import { useMemo } from "react";
import { cn } from "@/lib/utils";
import { renderInlineMarkdown, renderMarkdown } from "@/lib/markdown";

interface MarkdownProps {
  content: string;
  /** Emphasis only, rendered as a `span` so it can sit inside a paragraph. */
  inline?: boolean;
  className?: string;
}

export function Markdown({ content, inline = false, className }: MarkdownProps) {
  const html = useMemo(
    () => (inline ? renderInlineMarkdown(content) : renderMarkdown(content)),
    [content, inline],
  );

  if (inline) {
    return <span className={className} dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return (
    <div
      // `max-w-none` because these render inside cards and sidebars that have
      // already decided how wide the column is.
      className={cn("prose prose-sm dark:prose-invert max-w-none", className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
